import navConfig from "src/layouts/dashboard/navbar/NavConfig";
import { CustomerPermission, isFeatureVisibleForRole } from "src/pages/config/permission/permission";

export function invertColor(color: string, bw: boolean): string {
    if (color.startsWith('#')) {
        color = hexToRgb(color);
    }

    // Parse RGB values
    const match = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (!match) {
        throw new Error('Invalid RGB color format.');
    }

    let r = parseInt(match[1], 10);
    let g = parseInt(match[2], 10);
    let b = parseInt(match[3], 10);

    if (bw) {
        // Calculate luminance to determine whether to return black or white
        const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
        return luminance > 186 ? 'rgb(0, 0, 0)' : 'rgb(255, 255, 255)';
    }

    // Invert color components
    r = 255 - r;
    g = 255 - g;
    b = 255 - b;

    // Ensure values are within 0-255 range
    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));

    // Construct inverted RGB string
    return `rgb(${r}, ${g}, ${b})`;
}

function hexToRgb(hex: string): string {
    // Remove the leading # if present
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }

    // Convert 3-digit hex to 6-digit hex
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    // Validate the hex string
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }

    // Parse the hex string into RGB values
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    // Return the RGB string
    return `rgb(${r}, ${g}, ${b})`;
}

export const mergePermission = (
    userPermission: any,
    customerPermission: CustomerPermission[],
    userRoles: string[] = [],
) => {
    const featureSubheaders = navConfig.filter(x => x.isFeature).flatMap(y => y.subheader.toLowerCase());

    return Object.keys(userPermission).reduce((acc: any, key) => {
        const lowerKey = key.toLowerCase();

        if (featureSubheaders.includes(lowerKey)) {
            const feature = customerPermission.find((f) => f.key.toLowerCase() === lowerKey);
            if (!isFeatureVisibleForRole(feature, userRoles)) {
                return acc;
            }
        }

        acc[key] = userPermission[key];
        return acc;
    }, {});
};

export function onlyUnique(value: any, index: any, array: any) {
    return array.indexOf(value) === index;
}

export function getBgColor(banner: string) {
    if (!banner) return '#0627b7';

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = banner;
    const bannerDiv = tempDiv.querySelector('div');

    if (bannerDiv) {
        return bannerDiv.style.backgroundColor;
    }
}